import { Dashboard } from './dashboard_reducer';
import { Questionnaire } from './questionnaire_reducer';
import { User } from './user_reducer';
import { Reports } from './reports_reducer';
import { Facilites } from './facilites_reduser';
import { combineReducers } from 'redux';
import { Setting } from './setting_reducer';
import { Patients } from './admin/patients/patient_reducer';
import { AdminDashboard } from './admin/dashboard/dashboard_reducer';
import {Tickets} from './tickets_reducer';
import {Reasons} from './reason_reducer'

let AppReducer = combineReducers({
    User,
    Dashboard,
    Questionnaire,
    Facilites,
    Setting,
    Patients, // PatientReduser
    AdminDashboard,
    Reports,
    Tickets,
    Reasons
});
export default AppReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/